"use client";

/**
 * The one navigation slot that follows what the person is doing (owner,
 * 2026-10-02: "you wouldn't care about the map, probably, if you're only
 * here for the hot deals... you would only care about the alerts"):
 * the mobile tab bar's fourth slot is the map for home seekers and
 * everyone else, alerts for an investor, listing analytics for an agent.
 * The map then moves into the More sheet.
 *
 * Read from the last known intent in the browser (lib/use-personal
 * keeps it fresh whenever the homepage or the hub loads), so it costs
 * no request per page and does not swap under the thumb mid-session.
 */
import { useEffect, useState } from "react";
import { getCachedIntent } from "@/lib/use-personal";

export type AdaptiveSlot = "map" | "alerts" | "analytics";

export function slotFor(intent: string | null): AdaptiveSlot {
  if (intent === "invest") return "alerts";
  if (intent === "agent") return "analytics";
  return "map";
}

export function useAdaptiveSlot(): AdaptiveSlot {
  const [slot, setSlot] = useState<AdaptiveSlot>("map");
  useEffect(() => { setSlot(slotFor(getCachedIntent())); }, []);
  return slot;
}
